'use es6';

import http from 'hub-http/clients/apiClient';
import * as byModuleId from 'DesignData/api/CustomWidgetBuffersByModuleId';
import { STAGED } from 'DesignData/enums/StagingEnvironments';
import { formatPathSlug } from 'DesignData/lib/path';
export { byModuleId };
const BASE_API_PATH = 'designmanager/v1/modules';
/**
 * GET designmanager/v1/modules/:customWidgetId/buffer
 *
 * @param {Number}          customWidgetId - Optional query params.
 * @param {Object}          query - Optional query params.
 */

export function fetch(customWidgetId, query = {}) {
  return http.get(`${BASE_API_PATH}/${customWidgetId}/buffer`, {
    query
  });
}
/**
 * GET designmanager/v1/modules/buffer/by-path/:path
 *
 * @param {string} path - Module path.
 * @param {Object} query - Optional query params.
 */

export function fetchByPath(path, query = {}) {
  return http.get(`${BASE_API_PATH}/buffer/by-path/${formatPathSlug(path)}`, {
    query: Object.assign({}, query, {
      environmentId: STAGED
    })
  });
}
/**
 * PUT designmanager/v1/modules/:customWidgetId/buffer
 */

export function save(customWidgetId, saveData) {
  return http.put(`${BASE_API_PATH}/${customWidgetId}/buffer`, {
    data: saveData
  });
}
/**
 * GET designmanager/v1/modules/:customWidgetId/buffer/validate
 */

export function validate(customWidgetId) {
  return http.get(`${BASE_API_PATH}/${customWidgetId}/buffer/validate-with-warnings`);
}
/**
 * PUT designmanager/v1/modules/:customWidgetId/push-buffer-live
 */

export function publish(customWidgetId, publishData) {
  return http.put(`${BASE_API_PATH}/${customWidgetId}/push-buffer-live`, {
    data: publishData,
    timeout: 15000
  });
}
export function makeLocalCopy(customWidgetId, newName) {
  return http.post(`${BASE_API_PATH}/${customWidgetId}/make-local-copy`, {
    query: {
      newName
    }
  });
}
/**
 * POST designmanager/v1/modules/:customWidgetId/discard-buffer
 */

export function discardBuffer(customWidgetId) {
  return http.post(`${BASE_API_PATH}/${customWidgetId}/discard-buffer`);
}
/**
 * PUT designmanager/v1/modules/:customWidgetId/buffer/upgrade
 */

export function upgrade(customWidgetId, data = {}) {
  return http.put(`${BASE_API_PATH}/${customWidgetId}/buffer/upgrade`, {
    data
  });
}
/**
 * PUT /designmanager/v1/buffer/modules/by-path/p:path
 */

export function saveByPath(modulePath, moduleData) {
  return http.put(`${BASE_API_PATH}/buffer/by-path/${formatPathSlug(modulePath)}`, {
    data: moduleData,
    query: {
      environmentId: STAGED
    }
  });
}